var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_42_3",
    "data-name": "Component 42 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.833,
    height: 24.452,
    viewBox: "0 0 29.833 24.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M798.468,793.433a2.4,2.4,0,0,1-.633.907,16.894,16.894,0,0,1-2.047,1.905.677.677,0,0,0-.285.606A17.631,17.631,0,0,1,768.936,812.4c-.069-.04-.138-.081-.2-.126a.7.7,0,0,1-.089-.118,11.992,11.992,0,0,0,8.889-2.622,9.526,9.526,0,0,1-2.03-.455,5.955,5.955,0,0,1-3.492-3.421c-.182-.434-.167-.431.281-.4a5.809,5.809,0,0,0,2.261-.182,6.145,6.145,0,0,1-4.125-2.914,5.92,5.92,0,0,1-.708-3.18,7.1,7.1,0,0,0,2.546.744,2.437,2.437,0,0,0-.537-.6,6.655,6.655,0,0,1-2.021-4.108,5.736,5.736,0,0,1,.74-3.224c.138-.258.229-.164.364-.008a16.644,16.644,0,0,0,2.113,2.064,18.591,18.591,0,0,0,8.254,3.825c.589.117,1.182.2,1.776.271.3.038.333-.067.291-.325a6.165,6.165,0,0,1,10.3-5.551.6.6,0,0,0,.7.157,25.755,25.755,0,0,0,3.511-1.418,6.531,6.531,0,0,1-2.651,3.426,13.037,13.037,0,0,0,2.643-.6,1.657,1.657,0,0,1,.722-.193Z",
    transform: "translate(-768.643 -790.389)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M801.412,793.737v-.032l-.008.025Z",
    transform: "translate(-771.58 -790.686)",
    fill: "#989898"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwIcon);
export default __webpack_public_path__ + "static/media/tw-icon.74a41f2f7a4cd54c3102b7bd1ed045c7.svg";
export { ForwardRef as ReactComponent };